import script from "./WithdrawTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawTemplate.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawTemplate.vue?vue&type=style&index=0&id=7e9cac26&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9cac26"]])

export default __exports__